import { createContext, useContext } from "react";
import type { Lodging } from "@b2bportal/lodging-api";

export type HotelSortComparator = (a: Lodging, b: Lodging) => number;
export type HotelPriceExtractor = (lodging: Lodging) => number | null;

interface HotelListOverrideContextValue {
  sortComparator?: HotelSortComparator;
  priceExtractor?: HotelPriceExtractor;
}

export const HotelListOverrideContext = createContext<
  HotelListOverrideContextValue | undefined
>(undefined);

export const useHotelListOverride = () => useContext(HotelListOverrideContext);
